const Theme = {
  header_background_url: 'porthsp/porthsp.png',
  header_height: 200,
  logo_hidden: true,

  button_color: '#709FCF',
  button_text_color: '#FFFFFF',
  button_border_color: '#709FCF',

  button_hover_text_color: '#709FCF',
  button_hover_color: '#FFFFFF',
  button_hover_border_color: '#709FCF',

  button_border_width: 2,

  button_radius: 25,

  body_background_color: '#00528A',
}

export default Theme
